import angular from 'angular';
import taxInvoiceModal from './taxInvoiceModal';

export default angular
  .module('components.taxInvoiceModal', [])
  .component('taxInvoiceModal', taxInvoiceModal).name;
